// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<--------------------------------         New  works for cities          ----------------------------------------->>>>>>>>>>

// import React, { useState } from "react";
// import { Formik, Form, Field, ErrorMessage } from "formik";
// import * as Yup from "yup";
// import { ToastContainer, toast } from "react-toastify";
// import { Row, Col } from "antd";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { useTranslation } from "react-i18next";
// import { API_CREATE_ROLE } from "api/role-management";
// import { CONSTANTS } from "config/constant";

// const CreateArea = () => {
//   const { t } = useTranslation();
//   const navigate = useNavigate();
//   const [citySuggestions, setCitySuggestions] = useState([]);
//   const [subareaSuggestions, setSubareaSuggestions] = useState([]);

//   const fetchCities = async (input) => {
//     try {
//       const response = await axios.get(
//         `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${input}&types=(cities)&components=country:sa&key=${CONSTANTS.googleApikey}`
//       );
//       if (response.data.status === "OK") {
//         setCitySuggestions(response.data.predictions);
//       } else {
//         setCitySuggestions([]);
//         console.error("Error fetching cities");
//       }
//     } catch (error) {
//       setCitySuggestions([]);
//       console.error("Error fetching cities from Google Places API", error);
//     }
//   };

//   const fetchSubareas = async (city) => {
//     try {
//       const response = await axios.get(
//         `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${city}&types=(neighborhood)&components=country:sa&key=${CONSTANTS.googleApikey}`
//       );
//       if (response.data.status === "OK") {
//         setSubareaSuggestions(response.data.predictions);
//       } else {
//         setSubareaSuggestions([]);
//         console.error("Error fetching subareas");
//       }
//     } catch (error) {
//       setSubareaSuggestions([]);
//       console.error("Error fetching subareas from Google Places API", error);
//     }
//   };

//   const onSelectCity = (city, setFieldValue) => {
//     setFieldValue("city", city.description);
//     fetchSubareas(city.description);
//     setCitySuggestions([]);
//   };

//   const onSelectSubarea = (subarea, setFieldValue) => {
//     setFieldValue("sub_area", subarea.description);
//     setSubareaSuggestions([]);
//   };

//   return (
//     <div className="mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
//       <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
//         <Formik
//           initialValues={{
//             country: "Saudi Arabia",
//             city: "",
//             sub_area: "",
//           }}
//           validationSchema={Yup.object({
//             country: Yup.string().required("Required"),
//             city: Yup.string().required("Required"),
//             sub_area: Yup.string().required("Required"),
//           })}
//           onSubmit={async (values, { setSubmitting }) => {
//             console.log("values", values);
//             try {
//               const userData = await API_CREATE_ROLE(values);
//               toast.success(userData?.message);
//               navigate("/admin/area/area-tables");
//             } catch (error) {
//               console.error("error", error);
//               toast.error(error?.response?.data?.message);
//             } finally {
//               setSubmitting(false);
//             }
//           }}
//         >
//           {({ isSubmitting, values, setFieldValue }) => (
//             <Form className="flex min-h-[36rem] w-full flex-col justify-between rounded-[20px] bg-white p-8 shadow-md">
//               <Row gutter={[16, 16]}>
//                 <Col span={8}>
//                   <div className="mb-3">
//                     <label className="font-semibold">
//                       {t("Area Country")}
//                       <span className="text-[red]">*</span>
//                     </label>
//                     <Field
//                       className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-gray-200 p-3 text-sm outline-none cursor-not-allowed"
//                       type="text"
//                       name="country"
//                       readOnly
//                     />
//                     <ErrorMessage
//                       name="country"
//                       component="div"
//                       className="text-red-500"
//                     />
//                   </div>
//                 </Col>

//                 <Col span={8}>
//                   <div className="mb-3 relative">
//                     <label className="font-semibold">
//                       {t("Area City")}
//                       <span className="text-[red]">*</span>
//                     </label>
//                     <Field
//                       className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
//                       type="text"
//                       name="city"
//                       onChange={(e) => {
//                         setFieldValue("city", e.target.value);
//                         fetchCities(e.target.value);
//                       }}
//                     />
//                     {citySuggestions.length > 0 && (
//                       <div className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg">
//                         {citySuggestions.map((suggestion) => (
//                           <div
//                             key={suggestion.place_id}
//                             className="p-2 cursor-pointer hover:bg-gray-200"
//                             onClick={() => onSelectCity(suggestion, setFieldValue)}
//                           >
//                             {suggestion.description}
//                           </div>
//                         ))}
//                       </div>
//                     )}
//                     <ErrorMessage
//                       name="city"
//                       component="div"
//                       className="text-red-500"
//                     />
//                   </div>
//                 </Col>

//                 <Col span={8}>
//                   <div className="mb-3 relative">
//                     <label className="font-semibold">
//                       {t("Subarea")}
//                       <span className="text-[red]">*</span>
//                     </label>
//                     <Field
//                       className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
//                       type="text"
//                       name="sub_area"
//                       onChange={(e) => {
//                         setFieldValue("sub_area", e.target.value);
//                         fetchSubareas(values.city);
//                       }}
//                     />
//                     {subareaSuggestions.length > 0 && (
//                       <div className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg">
//                         {subareaSuggestions.map((suggestion) => (
//                           <div
//                             key={suggestion.place_id}
//                             className="p-2 cursor-pointer hover:bg-gray-200"
//                             onClick={() => onSelectSubarea(suggestion, setFieldValue)}
//                           >
//                             {suggestion.description}
//                           </div>
//                         ))}
//                       </div>
//                     )}
//                     <ErrorMessage
//                       name="sub_area"
//                       component="div"
//                       className="text-red-500"
//                     />
//                   </div>
//                 </Col>
//               </Row>
//               <div className="flex justify-end">
//                 <button
//                   type="submit"
//                   disabled={isSubmitting}
//                   className="linear mt-2 w-full max-w-[9rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
//                 >
//                   {isSubmitting ? t("Creating") + "..." : t("Create Area")}
//                 </button>
//               </div>
//             </Form>
//           )}
//         </Formik>
//       </div>
//     </div>
//   );
// };

// export default CreateArea;
// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<--------------------------------         New  works for cities  for the new         ----------------------------------------->>>>>>>>>>

import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { Row, Col } from "antd";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { API_CREATE_ROLE } from "api/role-management";
import { CONSTANTS } from "config/constant";
import { API_CREATE_AREA } from "api/area-management";

const CreateArea = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [citySuggestions, setCitySuggestions] = useState([]);
  const [subareaSuggestions, setSubareaSuggestions] = useState([]);
  const [selectedCityCoords, setSelectedCityCoords] = useState(null);
  const [subareaInputFocused, setSubareaInputFocused] = useState(false);

  const fetchCities = async (input) => {
    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${input}&types=(cities)&components=country:sa&key=${CONSTANTS.googleApikey}`
      );
      if (response.data.status === "OK") {
        setCitySuggestions(response.data.predictions);
      } else {
        setCitySuggestions([]);
        console.error("Error fetching cities");
      }
    } catch (error) {
      setCitySuggestions([]);
      console.error("Error fetching cities from Google Places API", error);
    }
  };

  const fetchSubareas = async (lat, lng) => {
    try {
      const subareaResponse = await axios.get(
        `https://maps.googleapis.com/maps/api/place/nearbysearch/json?location=${lat},${lng}&radius=5000&type=sublocality_level_1&key=${CONSTANTS.googleApikey}`
      );
      if (subareaResponse.data.status === "OK") {
        setSubareaSuggestions(subareaResponse.data.results);
      } else {
        setSubareaSuggestions([]);
        console.error("Error fetching subareas");
      }
    } catch (error) {
      setSubareaSuggestions([]);
      console.error("Error fetching subareas from Google Places API", error);
    }
  };

  const onSelectCity = async (city, setFieldValue) => {
    setFieldValue("city", city.description);
    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/place/details/json?place_id=${city.place_id}&key=${CONSTANTS.googleApikey}`
      );
      if (response.data.status === "OK") {
        const { lat, lng } = response.data.result.geometry.location;
        setSelectedCityCoords({ lat, lng });
        fetchSubareas(lat, lng);
      } else {
        console.error("Error fetching city details");
      }
    } catch (error) {
      console.error(
        "Error fetching city details from Google Places API",
        error
      );
    }
    setCitySuggestions([]);
  };

  const onSelectSubarea = (subarea, setFieldValue) => {
    console.log("subarea", subarea);
    setFieldValue("sub_area", subarea.name);
    setSubareaSuggestions([]);
  };

  return (
    <div className="mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
      <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
        <Formik
          initialValues={{
            country: "Saudi Arabia",
            city: "",
            sub_area: "",
          }}
          validationSchema={Yup.object({
            country: Yup.string().required("Required"),
            city: Yup.string().required("Required"),
            // sub_area: Yup.string().required("Required"),
          })}
          onSubmit={async (values, { setSubmitting }) => {
            console.log("values", values);
            try {
              const userData = await API_CREATE_AREA(values);
              toast.success(userData?.message);
              navigate("/admin/area/area-tables");
            } catch (error) {
              console.error("error", error);
              toast.error(error?.response?.data?.message);
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ isSubmitting, values, setFieldValue }) => (
            <Form className="flex min-h-[36rem] w-full flex-col justify-between rounded-[20px] bg-white p-8 shadow-md">
              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <div className="mb-3">
                    <label className="font-semibold">
                      {t("Area Country")}
                      <span className="text-[red]">*</span>
                    </label>
                    <Field
                      className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                      type="text"
                      name="country"
                      readOnly
                    />
                    <ErrorMessage
                      name="country"
                      component="div"
                      className="text-red-500"
                    />
                  </div>
                </Col>

                <Col span={8}>
                  <div className="relative mb-3">
                    <label className="font-semibold">
                      {t("Area City")}
                      <span className="text-[red]">*</span>
                    </label>
                    <Field
                      className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                      type="text"
                      name="city"
                      autoComplete="off"
                      onChange={(e) => {
                        setFieldValue("city", e.target.value);
                        fetchCities(e.target.value);
                      }}
                    />
                    {citySuggestions.length > 0 && (
                      <div className="absolute z-10 mt-1 w-full rounded-md border border-gray-300 bg-white shadow-lg">
                        {citySuggestions.map((suggestion) => (
                          <div
                            key={suggestion.place_id}
                            className="cursor-pointer p-2 hover:bg-gray-200"
                            onClick={() =>
                              onSelectCity(suggestion, setFieldValue)
                            }
                          >
                            {suggestion.description}
                          </div>
                        ))}
                      </div>
                    )}
                    <ErrorMessage
                      name="city"
                      component="div"
                      className="text-red-500"
                    />
                  </div>
                </Col>
                {/* <Col span={8}>
                  <div className="relative mb-3">
                    <label className="font-semibold">
                      {t("Subarea")}
                      <span className="text-[red]">*</span>
                    </label>
                    <Field
                      className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                      type="text"
                      name="sub_area"
                      autoComplete="new-password"
                      onFocus={() => setSubareaInputFocused(true)}
                      onBlur={() => setSubareaInputFocused(false)}
                      onChange={(e) => {
                        setFieldValue("sub_area", e.target.value);
                        if (selectedCityCoords) {
                          fetchSubareas(
                            selectedCityCoords.lat,
                            selectedCityCoords.lng
                          );
                        }
                      }}
                    />
                    {subareaInputFocused && subareaSuggestions.length > 0 && (
                      <div className="absolute z-10 mt-1 w-full rounded-md border border-gray-300 bg-white shadow-lg">
                        {subareaSuggestions.map((suggestion) => (
                          <div
                            key={suggestion.place_id}
                            className="cursor-pointer p-2 hover:bg-gray-200"
                            onClick={() =>
                              onSelectSubarea(suggestion, setFieldValue)
                            }
                          >
                            {suggestion.name}
                          </div>
                        ))}
                      </div>
                    )}
                    <ErrorMessage
                      name="sub_area"
                      component="div"
                      className="text-red-500"
                    />
                  </div>
                </Col> */}
                <Col span={8}>
                  <div className="relative mb-3">
                    <label className="font-semibold">
                      {t("Subarea")}
                      <span className="text-[red]">*</span>
                    </label>
                    <Field
                       className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"                      type="text"
                      name="sub_area"
                      autoComplete="new-password"
                      onFocus={() => setSubareaInputFocused(true)}
                      onBlur={() =>
                        setTimeout(() => setSubareaInputFocused(false), 200)
                      }
                      onChange={(e) => {
                        setFieldValue("sub_area", e.target.value);
                        if (selectedCityCoords) {
                          fetchSubareas(
                            selectedCityCoords.lat,
                            selectedCityCoords.lng
                          );
                        }
                      }}
                    />
                    {subareaInputFocused && subareaSuggestions.length > 0 && (
                      <div className="absolute z-10 mt-1 w-full rounded-md border border-gray-300 bg-white shadow-lg">
                        {subareaSuggestions.map((suggestion) => (
                          <div
                            key={suggestion.place_id}
                            className="cursor-pointer p-2 hover:bg-gray-200"
                            onClick={() =>
                              onSelectSubarea(suggestion, setFieldValue)
                            }
                          >
                            {suggestion.name}
                          </div>
                        ))}
                      </div>
                    )}
                    <ErrorMessage
                      name="sub_area"
                      component="div"
                      className="text-red-500"
                    />
                  </div>
                </Col>
                {/* <Col span={8}>
                  <div className="relative mb-3">
                    <label className="font-semibold">
                      {t("Subarea")}
                      <span className="text-[red]">*</span>
                    </label>
                    <Field
                      className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                      type="text"
                      name="sub_area"
                      onChange={(e) => {
                        setFieldValue("sub_area", e.target.value);
                        if (selectedCityCoords) {
                          fetchSubareas(
                            selectedCityCoords.lat,
                            selectedCityCoords.lng
                          );
                        }
                      }}
                    />
                    {subareaSuggestions.length > 0 && (
                      <div className="absolute z-10 mt-1 w-full rounded-md border border-gray-300 bg-white shadow-lg">
                        {subareaSuggestions.map((suggestion) => (
                          <div
                            key={suggestion.place_id}
                            className="cursor-pointer p-2 hover:bg-gray-200"
                            onClick={() =>
                              onSelectSubarea(suggestion, setFieldValue)
                            }
                          >
                            {suggestion.name}
                          </div>
                        ))}
                      </div>
                    )}
                    <ErrorMessage
                      name="sub_area"
                      component="div"
                      className="text-red-500"
                    />
                  </div>
                </Col> */}
              </Row>
              <div className="flex justify-end">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="linear mt-2 w-full max-w-[9rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                >
                  {isSubmitting ? t("Creating") + "..." : t("Create Area")}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default CreateArea;
